import i18n from 'i18next';

// Translate text that renders outside the React i18n tree, or in code that can run before
// i18n initialises (error-boundary fallback, non-React throws). Uses the bare i18next singleton
// (not `../i18n`, which fetches supported languages at import time) and falls back to the
// English default when i18next is not initialised, returns an empty string, or throws.
export function translateOrDefault(key: string, defaultValue: string): string {
  try {
    if (i18n.isInitialized) {
      const out = i18n.t(key, defaultValue);
      if (typeof out === 'string' && out !== '') {
        return out;
      }
    }
  } catch {
    // fall through to English
  }
  return defaultValue;
}
